import { STATUS } from "@/constant/statusConstants";
import * as Yup from "yup";
import createLocalizationsSchema from "../Localizations/createLocalizationsSchema";

const SportSchema = (localeCodes, isEdit = false) => Yup.object().shape({
  code: Yup
    .string()
    .label("ID")
    .required()
    .max(50),
  status: Yup
    .string()
    .label("Status")
    .required()
    .oneOf(Object.values(STATUS)),
  localizations: createLocalizationsSchema(localeCodes),
  icon: Yup.mixed().label("Icon").when([], {
    is: () => isEdit,
    then: (schema) => schema.nullable(),
    otherwise: (schema) => schema.required(),
  }),
});

export default SportSchema;
